import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=755a1bf6&scoped=true&"
import script from "./Action.vue?vue&type=script&lang=js&"
export * from "./Action.vue?vue&type=script&lang=js&"
import style0 from "./Action.vue?vue&type=style&index=0&id=755a1bf6&scoped=true&lang=css&"
import style1 from "./Action.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a1bf6",
  null
  
)

export default component.exports